import PropTypes from 'prop-types';
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import { Col, Row } from "reactstrap";
import InputController from "../../../../core/ui/components/InputController";
import {
    actualizarConfiguracion,
    crearOEditarConfiguracion,
} from "../../services/configuraciones-service";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

const FormConfiguraciones = ({ modalState, onSave }) => {
    const { configuracion } = modalState.data;

    const OPCIONES_TIPO = [
        { label: "Número", value: 1 },
        { label: "Porcentaje", value: 2 },
        { label: "Texto", value: 3 },
        { label: "Hora", value: 4 },
    ];

    const tipoConfiguracion = {
        label:
            configuracion.tipo == 1
                ? "Número"
                : configuracion.tipo == 2
                ? "Porcentaje"
                : configuracion.tipo == 3
                ? "Texto"
                : "Hora",
        value:
            configuracion.tipo == 1
                ? 1
                : configuracion.tipo == 2
                ? 2
                : configuracion.tipo == 3
                ? 3
                : 4,
    };

    const defaultValues = {
        id: configuracion.id || "",
        nombre: configuracion.nombre || "",
        valor: configuracion.valor || "",
        tipo: tipoConfiguracion,
        codigo: configuracion.codigo || "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [configuracion]);

    const onCreateConfiguracion = async (configuracion) => {
        if (["editar", "crear"].includes(modalState.data.tipo)) {
            const resp = await crearOEditarConfiguracion({
                ...configuracion,
                tipo: configuracion.tipo.value,
            });
            if (!resp.status) return toast.error(resp.message);

            toast.success(resp.message);
            modalState.close();
            onSave();
        } else {
            const resp = await actualizarConfiguracion({
                ...configuracion,
                tipo: configuracion.tipo.value,
            });
            if (!resp.status) return toast.error(resp.message);

            toast.success(resp.message);
            modalState.close();
            onSave();
        }
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formConfiguracion"
            onSubmit={onCreateConfiguracion}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={6}>
                    <InputController
                        name="nombre"
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Nombre"
                        readOnly={modalState.data.configuracion.id != null}
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="valor"
                        label="Valor"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Valor"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="tipo"
                        label="Tipo"
                        readOnly={modalState.data.configuracion.id != null}
                        rules={{ required: "Este campo es requerido" }}
                        options={OPCIONES_TIPO}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        name="codigo"
                        label="Codigo"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Codigo"
                        readOnly={modalState.data.configuracion.id != null}
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormConfiguraciones.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func,
}

export default FormConfiguraciones;
